import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1050.000000 1050.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1050.000000) scale(0.100000,-0.100000)">
<path d="M3960 5934 c-343 -44 -628 -167 -830 -360 -179 -171 -261 -379 -220
-555 15 -64 69 -172 109 -216 91 -99 261 -199 386 -227 22 -5 17 0 -20 20
-119 62 -217 170 -244 269 -26 96 -4 230 52 323 126 210 383 370 722 450 96
23 132 26 285 26 160 1 184 -2 280 -27 295 -79 464 -268 430 -482 -4 -27 -7
-51 -5 -53 1 -2 15 28 31 65 26 62 29 79 29 188 0 110 -2 125 -28 180 -89 191
-276 318 -560 380 -70 16 -344 28 -417 19z"/>
<path d="M6500 5560 l0 -200 35 0 35 0 0 200 0 200 -35 0 -35 0 0 -200z"/>
<path d="M5312 5558 l3 -193 35 0 35 0 1 70 c0 39 2 76 2 83 2 8 25 12 78 12
l75 0 -3 28 c-3 26 -5 27 -69 28 -37 1 -71 4 -76 7 -5 3 -9 25 -9 49 l1 43
103 3 102 3 0 29 0 30 -140 0 -140 0 2 -192z"/>
<path d="M6297 5703 c-4 -3 -7 -17 -7 -30 0 -16 -8 -27 -25 -33 -32 -12 -35
-59 -5 -67 17 -5 20 -14 20 -67 0 -84 23 -128 73 -139 47 -11 67 -4 67 25 0
17 -9 27 -30 35 -29 11 -30 13 -30 77 l0 66 30 0 c28 0 30 3 30 35 0 32 -2 35
-30 35 -26 0 -30 3 -30 29 0 17 -6 31 -16 35 -20 8 -39 8 -47 -1z"/>
<path d="M5705 5628 c-24 -14 -44 -39 -45 -55 0 -21 46 -26 74 -8 32 21 79 13
74 -12 -2 -12 -23 -22 -67 -33 -81 -19 -110 -50 -92 -100 6 -18 19 -39 28 -46
24 -18 84 -17 110 1 17 12 22 12 26 1 5 -13 67 -17 67 -3 0 4 0 52 0 108 0 98
-1 101 -29 130 -25 24 -37 29 -78 29 -26 0 -57 -6 -68 -12z m99 -170 c-9 -30
-23 -39 -54 -36 -33 4 -39 35 -8 47 13 6 33 10 46 10 20 1 22 -3 16 -21z"/>
<path d="M6013 5630 c-27 -11 -43 -40 -43 -78 0 -37 17 -51 89 -77 34 -12 56
-26 56 -35 0 -21 -62 -26 -84 -6 -21 19 -61 10 -61 -14 0 -31 37 -54 98 -58
52 -4 62 -1 90 23 60 50 35 106 -63 142 -71 26 -68 49 7 45 68 -4 83 11 44 45
-29 24 -89 30 -133 13z"/>
<path d="M6701 5614 c-17 -14 -31 -32 -31 -40 0 -22 48 -29 69 -10 19 18 48
21 70 7 24 -16 4 -39 -41 -46 -90 -15 -124 -48 -108 -107 15 -54 89 -77 137
-43 20 14 23 14 31 -1 6 -10 19 -14 38 -12 l29 3 0 95 c0 145 -23 180 -120
180 -32 0 -51 -7 -74 -26z m119 -147 c0 -28 -26 -49 -55 -45 -39 4 -42 39 -5
49 40 11 60 10 60 -4z"/>
<path d="M6994 5627 c-2 -7 -3 -69 -2 -138 l3 -124 35 0 35 0 5 98 c5 99 13
117 50 117 37 0 45 -18 50 -117 l5 -98 35 0 35 0 0 101 c0 110 -11 144 -52
163 -31 14 -79 14 -106 0 -16 -9 -22 -9 -25 0 -5 15 -61 14 -68 -2z"/>
<path d="M7400 5629 c-59 -23 -90 -131 -56 -198 43 -82 168 -97 229 -28 22 26
22 26 -9 37 -19 8 -31 6 -47 -5 -40 -28 -107 -12 -107 25 0 19 7 20 95 20 l95
0 0 26 c0 38 -28 91 -60 114 -30 22 -96 26 -140 9z m102 -66 c29 -26 21 -33
-37 -33 -41 0 -55 4 -55 15 0 33 62 46 92 18z"/>
<path d="M4390 5303 c-260 -19 -455 -81 -576 -184 -121 -103 -204 -301 -204
-487 l0 -39 242 -6 c133 -4 284 -7 336 -7 l94 0 -4 33 c-3 17 -21 88 -41 155
-21 68 -37 136 -37 152 0 51 15 53 168 31 77 -12 180 -24 230 -27 84 -6 89 -6
94 14 3 11 5 99 4 194 l-1 173 -130 1 c-71 0 -150 -1 -175 -3z"/>
<path d="M5310 4944 l0 -197 108 5 c118 5 153 17 195 67 52 62 59 135 21 216
-34 72 -115 105 -254 105 l-70 0 0 -196z m210 113 c39 -19 62 -73 57 -131 -4
-40 -11 -55 -36 -78 -27 -24 -40 -28 -91 -28 l-59 0 -3 125 -3 125 55 0 c30 0
66 -6 80 -13z"/>
<path d="M6080 5060 c0 -23 -4 -30 -20 -30 -16 0 -20 -7 -20 -35 0 -28 4 -35
20 -35 18 0 20 -7 20 -78 0 -70 3 -81 24 -101 13 -13 42 -25 65 -28 40 -6 41
-5 41 26 0 20 -5 31 -14 31 -31 0 -46 30 -46 91 0 59 0 59 30 59 28 0 30 3 30
35 0 32 -2 35 -30 35 -27 0 -30 3 -30 30 0 28 -3 30 -35 30 -32 0 -35 -2 -35
-30z"/>
<path d="M5780 5008 c-42 -29 -49 -51 -18 -65 18 -8 29 -6 50 10 18 14 34 18
53 13 40 -10 28 -39 -20 -49 -75 -16 -104 -34 -113 -69 -21 -77 51 -123 133
-86 21 9 28 9 34 -1 5 -7 21 -11 37 -9 l29 3 0 108 c-1 102 -2 109 -27 134
-38 38 -111 43 -158 11z m110 -152 c0 -24 -31 -47 -59 -44 -39 4 -36 41 4 49
48 11 55 10 55 -5z"/>
<path d="M6338 5014 c-24 -12 -48 -42 -48 -58 0 -2 13 -7 30 -11 21 -5 35 -2
46 9 26 26 74 17 74 -14 0 -13 -14 -20 -57 -29 -69 -13 -103 -42 -103 -86 0
-62 82 -98 141 -62 17 10 23 10 26 0 3 -7 20 -13 39 -13 l34 0 0 95 c0 111
-16 160 -55 175 -37 14 -95 12 -127 -6z m106 -152 c3 -5 -2 -18 -10 -30 -16
-23 -68 -31 -79 -12 -9 15 12 38 38 43 38 7 46 7 51 -1z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
